import React from "react";
import { motion } from "framer-motion";
import Logo from "../../assets/images/logo.png";

const Footer = () => {
  return (
    <footer className="bg-gray-800 text-white">
      <motion.div 
        className="flex justify-center items-center py-8"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
      >
        <motion.img 
          src={Logo} 
          alt="Luxury Car Rentals" 
          className="h-16 object-contain"
          whileHover={{ scale: 1.1 }}
          transition={{ duration: 0.3 }}
        />
      </motion.div>

      <motion.div 
        className="w-full h-px bg-gray-700"
        initial={{ scaleX: 0 }}
        whileInView={{ scaleX: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
      />

      <motion.div 
        className="py-4 text-center text-gray-400 text-sm"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5, delay: 0.3 }}
      >
        MYKONOS LUXURY YACHTS © {new Date().getFullYear()} POWERED AND CREATED BY{' '}
        <motion.a 
          href="https://create-website.gr" 
          target="_blank" 
          rel="noopener noreferrer"
          className="text-white hover:text-red-500 transition-colors duration-300"
          whileHover={{ scale: 1.1 }}
          transition={{ duration: 0.2 }}
        >
          CREATE-WEBSITE.GR
        </motion.a>
      </motion.div>
    </footer>
  );
};

export default Footer;